import { store } from "@/store";
import { ColorPickrState } from "@/types";
import { ActionTypes } from "@/store/actions";

function verifyPickrPayload(payload: ColorPickrState): payload is ColorPickrState {
  const validIds = ["canvas-bg-color", "fill-circle", "border-circle"];

  if (payload.id && validIds.includes(payload.id)) {
    return true;
  } else {
    throw new Error("Could not verify payload for color-picker, usePickr");
  }
}

export default (payload: ColorPickrState): void => {
  if (verifyPickrPayload(payload)) {
    if (payload.isOpen) {
      payload.isOpen = false;

      store.dispatch(ActionTypes.SET_COLOR_PICKR_STATE, payload);
    } else {
      payload.isOpen = true;

      store.dispatch(ActionTypes.SET_COLOR_PICKR_STATE, payload);
    }
  }
};
